// Restaurant configuration and data
export const navigationItems = [
  { id: 'home', label: 'INICIO' },
  { id: 'about', label: 'NOSOTROS' },
  { id: 'menu', label: 'MENÚ' },
  { id: 'gallery', label: 'GALERÍA' },
  { id: 'contact', label: 'CONTACTO' }
];

export const contactInfo = {
  phone: '+34 965 84 85 38',
  email: 'info@nouvalentino.com',
  address: {
    street: 'Centro Histórico de Altea la Vella',
    city: 'Costa Blanca, Alicante',
    country: 'España'
  },
  hours: {
    saturday: '13:00 - 15:30, 19:00 - 22:30',
    sunday: 'Cerrado',
    monday: 'Cerrado',
    tuesday: '13:00 - 15:30, 19:00 - 22:30',
    wednesday: '13:00 - 15:30, 19:00 - 22:30',
    thursday: '13:00 - 15:30, 19:00 - 22:30',
    friday: '13:00 - 15:30, 19:00 - 22:30'
  },
};